export default __webpack_public_path__ + "static/media/giftSetPickupIcon.c318b876.jpg";